"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDisabledDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var isBeforeModifier_1 = require("./isBeforeModifier");
var isDayOfWeekModifier_1 = require("./isDayOfWeekModifier");
var isDisabledDate = function (date, dates) {
    for (var _i = 0, _a = Array.isArray(dates) ? dates : [dates]; _i < _a.length; _i++) {
        var blackout = _a[_i];
        if (((0, isDayOfWeekModifier_1.isDayOfWeekModifier)(blackout) &&
            blackout.daysOfWeek.some(function (dayOfWeek) { return date.getDay() === dayOfWeek; })) ||
            (blackout instanceof Date && (0, dayjs_1.default)(date).isSame(blackout, "day")) ||
            ((0, isBeforeModifier_1.isBeforeModifier)(blackout) &&
                (0, dayjs_1.default)(date).isBefore(blackout.before, "day"))) {
            return true;
        }
    }
    return false;
};
exports.isDisabledDate = isDisabledDate;
